<div class="sort-selector">
    <div class="sort-selector-header" [class.collapsed]="collapsed">
        <div class="sort-selector-title" [class.expanded]="!collapsed">
            <button
                #sortheader
                class="ms-active-highlight"
                ds-button-icon
                kind="tertiary"
                variant="flat-reduced"
                size="medium"
                (click)="toggleSelector()">
                <vn-icon class="icon-alignment" name="theme-sorting" size="14"></vn-icon>
            </button>
        </div>
    </div>
    @if (!collapsed) {
        <div class="sort-selector-list">
            @if (showRadioInput) {
                <ds-radio-group size="large" [value]="radioSelected" (valueChange)="selectSortCriteria($event)">
                    <ds-radio-button name="Competition" [value]="gridSorting.Competition">{{
                        sitecore.eventGrid.SortByCompetitions
                    }}</ds-radio-button>
                    <ds-radio-button name="Competition" [value]="gridSorting.Time">{{ sitecore.eventGrid.SortByTime }}</ds-radio-button>
                </ds-radio-group>
            } @else {
                <div class="sort-selector-option" [class.active]="!sortByTime" (click)="selectSortCriteria(gridSorting.Competition)">
                    {{ sitecore.eventGrid.SortByCompetitions }}
                </div>
                <div class="sort-selector-option" [class.active]="sortByTime" (click)="selectSortCriteria(gridSorting.Time)">
                    {{ sitecore.eventGrid.SortByTime }}
                </div>
            }
        </div>
    }
</div>
<div class="sort-toggle">
    <div class="sort-toggle-text">{{ sitecore.eventGrid.SortBy }}</div>
    <ds-segmented-control
        [activeOption]="sortByTime ? gridSorting.Time.toString() : gridSorting.Competition.toString()"
        (activeOptionChange)="changeSortCriteria($event)">
        <ds-segmented-option [name]="gridSorting.Competition.toString()" [title]="sitecore.eventGrid.SortByCompetitions" />
        <ds-segmented-option [name]="gridSorting.Time.toString()" [title]="sitecore.eventGrid.SortByTime" />
    </ds-segmented-control>
</div>
